import { EventOrders, EventOrder } from './utils';

export enum EventOrdersEnum {
  GET_EVENT_ORDERS = 'event-orders/get',
  GET_EVENT_ORDER = '/event-order/get',
  POST_CREATE_EVENT_ORDER = 'event-order/create',
  POST_CANCEL_EVENT_ORDERS = 'event-orders/cancel',
  PATCH_HIDE_ORDER = 'event-order/hide',
}

export type Params = {
  page: string;
  limit: string;
};

export type Payload = {
  user_comment: string;
  program_name: string;
  competence_id: string;
  profession_id: string;
  prof_sphere_id: string;
  competence_new: string;
  cost_max: string | number;
  students_count: string | number;
  modules: Array<string | number>;
  edu_cats: Array<string | number>;
  edu_forms: Array<string | number>;
  edu_durations: Array<string | number>;
};

export type OrdersParser = (data: EventOrders) => any;
export type OrderParser = (data: EventOrder) => any;



// WEBPACK FOOTER //
// ./src/services/api/event-orders/types.ts